export default __webpack_public_path__ + "static/avatar-kortical-team3-7827237e5476417f116031aa6890d11d.webp";